import { DollarSign, CreditCard, Shield, Camera, Activity, FileDown, Send } from 'lucide-react';

const features = [
  {
    icon: DollarSign,
    title: 'Budgets & categories',
    description: 'Set spending limits by category, team, or project. Get alerts before limits are reached.'
  },
  {
    icon: CreditCard,
    title: 'Team cards with roles',
    description: 'Issue virtual or physical cards to team members with custom spending permissions and controls.'
  },
  {
    icon: Shield,
    title: 'Merchant/category controls',
    description: 'Block or allow specific merchants and categories. Prevent unauthorized spending automatically.'
  },
  {
    icon: Send,
    title: 'Vendor transfers',
    description: 'Pay vendors and contractors with transaction references for easy reconciliation. Track all outgoing payments.'
  },
  {
    icon: Camera,
    title: 'Receipt capture + notes',
    description: 'Snap photos of receipts instantly. Add notes and categorize expenses on the go.'
  },
  {
    icon: Activity,
    title: 'Real-time activity feed',
    description: 'See every transaction as it happens. Monitor team spending with complete visibility.'
  },
  {
    icon: FileDown,
    title: 'Export-ready records',
    description: 'Download clean CSV exports for accounting. All receipts and notes included for audit compliance.'
  }
];

const Features = () => {
  return (
    <section id="features" className="py-24 md:py-32 relative">
      <div className="container mx-auto">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl md:text-5xl font-bold heading-font text-white">
            Everything you need to
            <span className="block mt-2 text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 to-cyan-400">
              manage team spending
            </span>
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Control costs, capture receipts, and stay audit-ready with powerful spend management tools.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="group p-8 bg-white/5 rounded-2xl border border-white/10 hover:border-white/20 transition-all hover:bg-white/10 backdrop-blur-sm"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="w-12 h-12 bg-indigo-600/20 rounded-xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                  <Icon size={24} className="text-indigo-400" />
                </div>
                <h3 className="text-xl font-semibold text-white mb-3 heading-font">
                  {feature.title}
                </h3>
                <p className="text-gray-400 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
